import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

import { determineSecondBankFormEligibility } from "./utils";

export class SignatoryNameField extends Field<string> {
  constructor(
    model: Merchant,
    { propertyName }: { propertyName: string },
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "Best Company",
      propertyName,
      uiFieldType: "Input",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;
    const signatoryType = this._model.primaryBank.signatoryType.value;
    const signatoryType2 = this._model.secondaryBank.signatoryType2.value;

    if (registeredCountry === "New Zealand") {
      if (this.propertyName === "signatoryName2") {
        return (
          signatoryType2 == "One Signatory" &&
          determineSecondBankFormEligibility({
            salesChannel,
            registeredCountry,
          })
        );
      }

      if (signatoryType == "One Signatory") return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
